import React from 'react';
import { LockIcon, SparklesIcon, StarIcon } from './Icons';
import { useClient } from '../contexts/ClientContext';

interface DivinationBlurLockProps {
    title: string;
    subtitle?: string;
    featureName?: string;
}

export const DivinationBlurLock: React.FC<DivinationBlurLockProps> = ({
    title,
    subtitle = "Connectez-vous ou créez votre compte gratuit en 10 secondes pour dévoiler votre interprétation complète et la conserver dans votre profil.",
    featureName = "votre révélation complète"
}) => {
    const { openAuthModal } = useClient();

    return (
        <div className="absolute inset-0 z-30 flex flex-col items-center justify-center p-4 sm:p-6 bg-black/60 backdrop-blur-md rounded-2xl sm:rounded-3xl border border-gold-500/40 shadow-2xl animate-fade-in text-center">
            <div className="relative mb-4 group">
                <div className="absolute -inset-2 bg-gradient-to-r from-gold-500 via-purple-500 to-amber-500 rounded-full blur-md opacity-75 group-hover:opacity-100 transition duration-500 animate-pulse"></div>
                <div className="relative w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-purple-950/90 border-2 border-gold-400 flex items-center justify-center shadow-xl">
                    <LockIcon className="w-7 h-7 sm:w-8 sm:h-8 text-gold-400" />
                </div>
            </div>
            <h3 className="text-xl sm:text-2xl md:text-3xl font-serif font-bold text-transparent bg-clip-text bg-gradient-to-r from-gold-300 via-white to-purple-200 mb-2 drop-shadow">
                {title}
            </h3>
            <p className="text-gray-200 text-xs sm:text-sm md:text-base max-w-md mx-auto mb-6 leading-relaxed font-light">
                {subtitle}
            </p>
            <button
                onClick={() => openAuthModal()}
                className="w-full sm:w-auto px-8 py-4 bg-gradient-to-r from-gold-500 via-amber-400 to-gold-500 hover:from-gold-400 hover:to-gold-600 text-black font-bold rounded-full shadow-[0_0_30px_rgba(251,191,36,0.4)] transition-all hover:scale-105 uppercase tracking-widest text-xs sm:text-sm flex items-center justify-center gap-3 cursor-pointer"
            >
                <SparklesIcon className="w-4 h-4 sm:w-5 sm:h-5 text-black" />
                Se connecter pour révéler
            </button>
            <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-6 mt-6 text-[10px] sm:text-xs text-purple-200/80">
                <span className="flex items-center gap-1.5">
                    <StarIcon className="w-3.5 h-3.5 text-gold-400" /> 100 Astres offerts à l'inscription
                </span>
                <span className="flex items-center gap-1.5">
                    <span className="w-1.5 h-1.5 rounded-full bg-emerald-400"></span> 100% Gratuit & Sans engagement
                </span>
                <span className="flex items-center gap-1.5">
                    Données 100% confidentielles
                </span>
            </div>
        </div>
    );
};

export default DivinationBlurLock;
